import { useMemo } from "react";

import { FetchGet } from "@/lib/fetch-helper";
import { useQueryCustom } from "@/src/query-client-overrides";
import { urlFormat } from "@Components/Modules/Helpers";
import { Consents } from "@Routes/AccountLinks";

enum ConsentType {
    Undefined,
    Consent,
    Statement,
}

export interface IConsentItem {
    id: string;
    shortDescription: string;
    longDescription: string;
    isRequired: boolean;
    isSelectable: boolean;
    isSelectedByDefault: boolean;
    consentType: ConsentType;
}

export interface IConsentItemStatus {
    id: string;
    isChecked: boolean;
}

export enum ConsentScreenType {
    Undefined = 0,
    LoginProcess = 1,
    RegistrationProcess = 2,
    MgmRegistrationProcess = 7,
}

export type ConsentsResponse = { data: IConsentItem[] };

export const useConsents = (consentType: ConsentScreenType) => {
    const { data } = useQueryCustom({
        queryKey: [consentType],
        queryFn: () =>
            FetchGet<ConsentsResponse>(urlFormat(Consents.url, { consentScreenType: consentType })),
    });

    const consents = useMemo(
        () =>
            data.data?.map((consent) => ({
                ...consent,
            })) || [],
        [data],
    );

    return consents;
};
